/**
 * Utility per calcolare i flag temporali degli eventi (oggi, domani, weekend, etc.)
 */

import { hasWeekendDay } from "./date-utils";

function startOfDay(d: Date) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function endOfDay(d: Date) {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
}

function addDays(d: Date, n: number) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

function isRangeOverlap(aStart: number, aEnd: number, bStart: number, bEnd: number) {
  return aEnd >= bStart && aStart <= bEnd;
}

export type DateFlags = {
  isToday?: boolean;
  isTomorrow?: boolean;
  isThisWeekend?: boolean;
  isThisWeek?: boolean;
  isComingSoon?: boolean;
  isConcluded?: boolean;
};

export function computeDateFlags(startISO?: string, endISO?: string, maxDaysAhead?: number): DateFlags {
  const now = new Date();
  const todayStart = startOfDay(now).getTime();
  const todayEnd = endOfDay(now).getTime();

  if (!startISO && !endISO) {
    // niente date: trattiamolo come "in arrivo" generico
    return { isComingSoon: true };
  }

  const s = startISO ? new Date(startISO).getTime() : undefined;
  const e = endISO ? new Date(endISO).getTime() : s;
  const startTS = s ?? 0;
  const endTS = e ?? 0;

  // concluso
  const isConcluded = endTS < todayStart;

  // oggi
  const isToday = isRangeOverlap(startTS, endTS, todayStart, todayEnd);

  // domani
  const tomStart = startOfDay(addDays(now, 1)).getTime();
  const tomEnd = endOfDay(addDays(now, 1)).getTime();
  const isTomorrow = isRangeOverlap(startTS, endTS, tomStart, tomEnd);

  // questa settimana (lun-dom): semplifichiamo usando 7 giorni da oggi
  const weekEnd = endOfDay(addDays(now, 6)).getTime();
  const isThisWeek = isRangeOverlap(startTS, endTS, todayStart, weekEnd);

  // questo weekend: verifica se l'evento ha almeno un giorno che è ven/sab/dom
  const isThisWeekend = startISO ? hasWeekendDay(startISO, endISO) : false;

  // in arrivo: non iniziato e entro maxDaysAhead (default 30 giorni, ma può essere esteso)
  const daysLimit = maxDaysAhead ?? 30;
  const isComingSoon = startTS > todayEnd && startTS <= endOfDay(addDays(now, daysLimit)).getTime();

  return { isToday, isTomorrow, isThisWeekend, isThisWeek, isComingSoon, isConcluded };
}

